import {
  AlertCaption,
  InputGroupPropsType,
  useSwitchAlertIcon,
} from "@/lib/main";
import { CSSProperties, useState } from "react";
import Input from "./Input";
import Label from "./Label";
import PlaceholderIcon from "./PlaceholderIcon";

export default function InputGroup({
  children,

  label,
  icon,

  name,
  autoComplete,
  maxLength,
  placeholder,
  value,
  setValue,

  valueValid,
  min,
  max,
  required,
  disabled,

  inputRef,
  inputKeyDown,
  type,

  message,
  alertColor,

  fullWidth,
}: InputGroupPropsType) {
  const containerStyles: CSSProperties = {
    position: "relative",
    marginTop: "var(--spacing-xs)",
    marginBottom: "var(--spacing-sm)",
  };
  if (!alertColor) alertColor = "assist";
  const alertIcon = useSwitchAlertIcon(alertColor);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const handleClick = () => setIsPasswordVisible(!isPasswordVisible);

  return (
    <Label label={label} disabled={disabled} fullWidth={fullWidth}>
      <div style={containerStyles}>
        {icon ? <PlaceholderIcon name={icon} disabled={disabled} /> : null}

        <Input
          name={name}
          autoComplete={autoComplete || "off"}
          maxLength={maxLength}
          placeholder={placeholder}
          value={value}
          setValue={setValue}
          valueValid={valueValid}
          min={min}
          max={max}
          required={required}
          disabled={disabled}
          inputRef={inputRef}
          inputKeyDown={inputKeyDown}
          type={isPasswordVisible ? "text" : type}
          alertColor={alertColor}
          fullWidth={fullWidth}
          icon={icon}
        />

        {type === "password" ? (
          <PlaceholderIcon
            name={isPasswordVisible ? "eye-closed" : "eye-open"}
            disabled={disabled}
            onClick={handleClick}
            end
          />
        ) : null}
      </div>

      {children}

      {message ? (
        <AlertCaption color={alertColor} icon={alertIcon}>
          {message}
        </AlertCaption>
      ) : null}
    </Label>
  );
}
